// ** MUI Imports
import { styled, useTheme } from '@mui/material/styles'
import MuiSwipeableDrawer from '@mui/material/SwipeableDrawer'

const SwipeableDrawer = styled(MuiSwipeableDrawer)(({ theme }) => ({
  overflowX: 'hidden',
  transition: 'width .25s ease-in-out',
  '& ul': {
    listStyle: 'none'
  },
  '& .MuiListItem-gutters': {
    paddingLeft: 4,
    paddingRight: 4
  },
  '& .MuiDrawer-paper': {
    left: 'unset',
    right: 'unset',
    overflowX: 'hidden',
    transition: 'width .25s ease-in-out, box-shadow .25s ease-in-out'
  },

  /*
    Esta regla es la que arregla el CLS de la home en movil.

    `variant` depende de `hidden`, que sale de useMediaQuery. En servidor
    useMediaQuery no tiene viewport y devuelve false, asi que el HTML estatico
    siempre sale con el drawer 'permanent'. Un drawer permanente es hijo del
    flex de VerticalLayoutWrapper y ocupa sus 260 px: medido con CDP a 412 px de
    ancho, el <main> nacia en x=260 con 152 px utiles y, al hidratar, saltaba a
    x=0 con 412 px. Todo el contenedor de contenido —8.238 px de alto— se
    reacomodaba de golpe. Lighthouse lo medio en 0,85 de CLS, casi todo el
    puntaje de rendimiento que falta.

    Sacandolo del flujo por CSS debajo de lg, el primer pintado ya sale con el
    ancho correcto y el cambio a 'temporary' (que es position:fixed y no ocupa
    espacio) no mueve nada. Arriba de lg la regla no aplica y el permanente se
    comporta igual que siempre.

    Va sobre .MuiDrawer-docked a proposito: es la clase que MUI pone solo en las
    variantes permanent y persistent. El drawer temporal lleva .MuiDrawer-modal,
    asi que el menu hamburguesa de movil sigue abriendo normalmente.
  */
  [theme.breakpoints.down('lg')]: {
    '&.MuiDrawer-docked': {
      display: 'none'
    }
  }
}))

const Drawer = props => {
  // ** Props
  const {
    hidden,
    children,
    navHover,
    navWidth,
    settings,
    navVisible,
    setNavHover,
    navMenuProps,
    setNavVisible,
    collapsedNavWidth,
    navigationBorderWidth
  } = props

  // ** Hook
  const theme = useTheme()

  // ** Vars
  const { navCollapsed } = settings
  let flag = true

  // Drawer Props for Mobile & Tablet screens
  const MobileDrawerProps = {
    open: navVisible,
    onOpen: () => setNavVisible(true),
    onClose: () => setNavVisible(false),
    ModalProps: {
      keepMounted: true // Better open performance on mobile.
    }
  }

  // Drawer Props for Laptop & Desktop screens
  const DesktopDrawerProps = {
    open: true,
    onOpen: () => null,
    onClose: () => null,
    onMouseEnter: () => {
      // Declared flag to resolve first time flicker issue while trying to collapse the menu
      if (flag || navCollapsed) {
        setNavHover(true)
        flag = false
      }
    },
    onMouseLeave: () => {
      if (navCollapsed) {
        setNavHover(false)
      }
    }
  }
  let userNavMenuStyle = {}
  let userNavMenuPaperStyle = {}
  if (navMenuProps && navMenuProps.sx) {
    userNavMenuStyle = navMenuProps.sx
  }
  if (navMenuProps && navMenuProps.PaperProps && navMenuProps.PaperProps.sx) {
    userNavMenuPaperStyle = navMenuProps.PaperProps.sx
  }
  const userNavMenuProps = Object.assign({}, navMenuProps)
  delete userNavMenuProps.sx
  delete userNavMenuProps.PaperProps

  return (
    <SwipeableDrawer
      className='layout-vertical-nav'
      variant={hidden ? 'temporary' : 'permanent'}
      {...(hidden ? { ...MobileDrawerProps } : { ...DesktopDrawerProps })}
      PaperProps={{
        sx: {
          backgroundColor: 'background.default',
          width: navCollapsed && !navHover ? collapsedNavWidth : navWidth,
          ...(!hidden && navCollapsed && navHover ? { boxShadow: 9 } : {}),
          borderRight: navigationBorderWidth === 0 ? 0 : `${navigationBorderWidth}px solid ${theme.palette.divider}`,
          ...userNavMenuPaperStyle
        },
        ...navMenuProps?.PaperProps
      }}
      sx={{
        width: navCollapsed ? collapsedNavWidth : navWidth,
        ...userNavMenuStyle
      }}
      {...userNavMenuProps}
    >
      {children}
    </SwipeableDrawer>
  )
}

export default Drawer
